<template>
  <div class="position-relative bg-white" :style="'z-index:' + index" ref="searchBlock">
    <div
      class="border p-2 h-100 position-relative text-nowrap" ref="searchLabel"
      @click="showDropdown = !showDropdown">
      {{ item.label }}
      <div
        class="position-absolute"
        :style="'right:2%;top:50%;height:20px;line-height:20px;margin-top:-10px;z-index:' + index">
        &dtrif;
      </div>
    </div>
    <div
      v-if="showDropdown"
      class="position-absolute bg-white overflow-auto w-100"
      :style="'top:100%;margin-top:2px;height:38px;left:0;z-index:' + index">
      <input
        type="text"
        class="form-control m-0"
        placeholder="Search..."
        v-model="search"
        ref="searchInput"/>
    </div>
    <div
      v-if="showDropdown"
      class="position-absolute bg-white border overflow-auto w-100"
      :style="'top:100%;margin-top:38px;left:0;max-height:200px;z-index:' + index">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="border-top p-2"
        style="min-height:38px;"
        @click="select(item)">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Select',

  props: ['data', 'placeholder', 'value'],

  data() {
    return {
      search: '',
      item: '',
      index: 1000,
      showDropdown: false,
    };
  },

  created() {
    if (this.data.length > 0) {
      const item = this.data.find(i => i.value === this.value);

      this.item = item ? item : this.data[0];
    }
  },

  computed: {
    list() {
      return this.data.filter(item => {
        const label = item.label.toLowerCase();
        const search = this.search.toLowerCase();

        return search === '' || label.indexOf(search) !== -1;
      });
    },
  },

  methods: {
    select(item) {
      this.item = item;
      this.showDropdown = false;
    },
  },

  watch: {
    data(value) {
      if (value.length > 0) {
        const itemExists = value.find(item => item.value === this.value);

        if (!itemExists) {
          this.item = value[0];
        }
      }
    },

    item(item) {
      this.$emit('input', item.value);
    },

    showDropdown(value) {
      const self = this;

      this.index = value ? 10000 : 1000;

      const clickListener = function (e) {
        if (![self.$refs.searchBlock, self.$refs.searchLabel, self.$refs.searchInput].includes(e.target)) {
          self.showDropdown = false;
        }
      };

      if (value) {
        document.addEventListener('click', clickListener);
      } else {
        document.removeEventListener('click', clickListener);
      }
    },
  },
};
</script>
